export default {
  loggedIn: function() {
    var userData = localStorage.getItem('userData')
    var chkval = false
    if (userData) {
      var userInfo = JSON.parse(userData)
      this.email = userInfo.sysemailid
      var d1 = new Date()
      var activeTime = localStorage.getItem('activeTime')
      var currTime = d1.getMinutes()
      var timeDiff = currTime - activeTime
      if (timeDiff >= 20 || activeTime === null || activeTime === '') {
        localStorage.setItem('userData', '')
        localStorage.setItem('activeTime', '')
        chkval = true
        return true
      }
      if (this.email !== '') {
        chkval = false
        return false
      } else {
        chkval = true
        return true
      }
    } else {
      chkval = true
      return true
    }
    return chkval
  },
  checkValidUser: function() {
    var userData = localStorage.getItem('userData')
    if (userData) {
      var chkval = false
        var userInfo = JSON.parse(userData)
        if(userInfo.sysusermasterid === 1){
          chkval = true
          return true
        }
    }
    return chkval
  },

  onChange() {}
}
